import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogApi from '../api/blogApi';
import { useAuth } from '../context/AuthContext';

const PostDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoggedIn } = useAuth();
    const [post, setPost] = useState(null);

    useEffect(() => {
        blogApi.get(`/api/blog/posts/${id}/`)
            .then(res => setPost(res.data))
            .catch(err => console.error('게시글 조회 실패:', err));
    }, [id]);

    const handleDelete = async () => {
        if (!window.confirm('정말 삭제하시겠습니까?')) return;

        try {
            await blogApi.delete(`/api/blog/posts/${id}/`);
            alert('게시글이 삭제되었습니다.');
            navigate('/posts');
        } catch (err) {
            console.error(err);
            alert('삭제 중 오류가 발생했습니다.');
        }
    };

    if (!post) return <div className="p-8">Loading...</div>;

    return (
        <div className="max-w-3xl mx-auto p-8">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-3xl font-bold">{post.title}</h1>
                {isLoggedIn && (
                    <div className="flex gap-2">
                        <button
                            onClick={() => navigate(`/posts/${id}/edit`)}
                            className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
                        >
                            수정
                        </button>
                        <button
                            onClick={handleDelete}
                            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                        >
                            삭제
                        </button>
                    </div>
                )}

            </div>
            <p className="text-gray-600 mb-2">작성자: {post.author_name}</p>
            <p className="text-gray-400 text-sm mb-6">
                작성일: {new Date(post.created_at).toLocaleString()}
            </p>
            <div className="bg-white p-6 rounded shadow text-gray-800 leading-relaxed whitespace-pre-line">
                {post.content}
            </div>
        </div>
    );
};

export default PostDetail;
